import React, { useContext } from 'react'
import { css } from '@emotion/core'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { SettingsLayout } from '@/components/layouts/settings-layout'
import { InputField } from '@/components/molecules/input-field'
import { EditFooter } from '@/components/organisms/edit-footer'
import { CheckinTabContainer } from '@/components/organisms/settings/checkin-tab-container'
import { TabContainer } from '@/components/organisms/settings/tab-container'
import { AccountContext } from '@/contexts/account'
import { useCardReaderSetting } from '@/hooks/self-checkin-device-settings/use-card-reader-setting'

export const SelfCheckinCardReader: React.FC = () => {
  const { t } = useTranslation()
  const { account } = useContext<any>(AccountContext)
  const hotelId: string = account?.hotel?.id || account?.employee?.hotelId || ''
  const { control, isDirty, isLoading, checkResult, save, cancel } = useCardReaderSetting(hotelId)
  const footerContent = isDirty ? <EditFooter onSave={save} onCancel={cancel} /> : undefined

  return (
    <SettingsLayout loading={isLoading} footerContent={footerContent}>
      <TabContainer tabComponent={<CheckinTabContainer currentTab="Card reader" />} isShowFooter={isDirty}>
        <div css={containerStyle}>
          <div css={fieldStyle}>
            <div className="input-label">{t('Serial number')}</div>
            <Controller
              control={control}
              name="serialNumber"
              render={({ field: { onChange, value } }) => <InputField value={value} handleChangeData={onChange} />}
            />
          </div>
          <div css={fieldStyle}>
            <div className="input-label">PC ID</div>
            <Controller
              control={control}
              name="pcId"
              render={({ field: { onChange, value } }) => <InputField value={value} handleChangeData={onChange} />}
            />
          </div>
          {checkResult && (
            <div className={checkResult.is_success ? 'connect-success-text' : 'connect-error-text'}>{checkResult.message}</div>
          )}
        </div>
      </TabContainer>
    </SettingsLayout>
  )
}

const containerStyle = css({
  padding: 32,
  '.input-label': {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 12,
  },
  '.connect-success-text': {
    marginTop: 14,
    color: '#676767',
    fontSize: 12,
  },
  '.connect-error-text': {
    marginTop: 14,
    color: 'rgba(255,0,0,0.5)',
    fontSize: 12,
  },
})

const fieldStyle = css({ width: 300 })
